import { relations, sql } from "drizzle-orm";
import {
  check,
  index,
  integer,
  pgEnum,
  pgTable,
  primaryKey,
  text,
  uuid,
} from "drizzle-orm/pg-core";
import { id, timestamps } from "../../utils/sql";
import { foodCategoryAssociationTypes } from "./constants";

export const foodCategoryAssociationType = pgEnum(
  "food_category_association_type",
  foodCategoryAssociationTypes,
);

export const foodCategory = pgTable("food_category", {
  ...id,
  ...timestamps,
  name: text("name").notNull(),
  key: text("key").notNull().unique(),
});

export const foodCategoryRelations = relations(foodCategory, ({ many }) => ({
  sourceEdges: many(foodCategoryEdge, { relationName: "foodCategoryEdgeSource" }),
  destinationEdges: many(foodCategoryEdge, { relationName: "foodCategoryEdgeDestination" }),
  ancestorClosures: many(foodCategoryClosure, { relationName: "foodCategoryClosureAncestor" }),
  descendantClosures: many(foodCategoryClosure, {
    relationName: "foodCategoryClosureDescendant",
  }),
}));

export const foodCategoryEdge = pgTable(
  "food_category_edge",
  {
    sourceId: uuid("source_id")
      .notNull()
      .references(() => foodCategory.id),
    destinationId: uuid("destination_id")
      .notNull()
      .references(() => foodCategory.id),
  },
  (t) => [
    primaryKey({
      name: "food_category_edge_pk",
      columns: [t.sourceId, t.destinationId],
    }),
    check("food_category_edge_no_self_loop", sql`${t.sourceId} != ${t.destinationId}`),
    index("food_category_edge_source_idx").on(t.sourceId),
    index("food_category_edge_destination_idx").on(t.destinationId),
  ],
);

export const foodCategoryEdgeRelations = relations(foodCategoryEdge, ({ one }) => ({
  source: one(foodCategory, {
    fields: [foodCategoryEdge.sourceId],
    references: [foodCategory.id],
    relationName: "foodCategoryEdgeSource",
  }),
  destination: one(foodCategory, {
    fields: [foodCategoryEdge.destinationId],
    references: [foodCategory.id],
    relationName: "foodCategoryEdgeDestination",
  }),
}));

export const foodCategoryClosure = pgTable(
  "food_category_closure",
  {
    ancestorId: uuid("ancestor_id")
      .notNull()
      .references(() => foodCategory.id),
    descendantId: uuid("descendant_id")
      .notNull()
      .references(() => foodCategory.id),
    depth: integer("depth").notNull(),
    pathCount: integer("path_count").notNull(),
  },
  (t) => [
    primaryKey({
      name: "food_category_closure_pk",
      columns: [t.ancestorId, t.descendantId, t.depth],
    }),
    check("food_category_closure_depth_nonnegative", sql`${t.depth} >= 0`),
    check("food_category_closure_path_count_positive", sql`${t.pathCount} > 0`),
    index("food_category_closure_ancestor_idx").on(t.ancestorId),
    index("food_category_closure_descendant_idx").on(t.descendantId),
  ],
);

export const foodCategoryClosureRelations = relations(foodCategoryClosure, ({ one }) => ({
  ancestor: one(foodCategory, {
    fields: [foodCategoryClosure.ancestorId],
    references: [foodCategory.id],
    relationName: "foodCategoryClosureAncestor",
  }),
  descendant: one(foodCategory, {
    fields: [foodCategoryClosure.descendantId],
    references: [foodCategory.id],
    relationName: "foodCategoryClosureDescendant",
  }),
}));
